import { currentBrand, isHmBrand, isNorthstarBrand } from '@pb/utils'

export const TRACKING_EVENTS = {
  digitalReceiptClick: {
    id: 'digitalReceiptClick',
    data: {
      event_type: 'CLUB_DIGITAL_RECEIPTS_PDF',
      event_id: 'Digital Receipt',
      event_category: 'Club',
      event_label: 'Open PDF',
    },
  },
  digitalReceiptError: {
    id: 'digitalReceiptError',
    data: {
      event_type: 'CLUB_DIGITAL_RECEIPTS_ERROR',
      event_id: 'Error Message',
      event_category: 'Club',
    },
  },
  inboxView: {
    id: 'inboxView',
    data: {
      event_type: 'INBOX_MESSAGE_VIEW',
      event_id: 'Message viewed',
      event_category: 'My account inbox',
    },
  },
  messageClick: {
    id: 'messageClick',
    data: {
      event_type: 'INBOX_MESSAGE_CLICK',
      event_id: 'Message clicked',
      event_category: 'My account inbox',
    },
  },
  messagesError: {
    id: 'messagesError',
    data: {
      event_type: 'INBOX_ERROR',
      event_id: 'Error message',
      event_category: 'My account inbox',
    },
  },
  addDiscount: {
    id: 'addDiscount',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'ADD_DISCOUNT' : 'discount_added_success',
      event_id: 'Add discount code',
      event_category: 'Discount',
      event_label: 'Discount offer',
    },
  },
  addDiscountFromCart: {
    id: 'addDiscountFromCart',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'ADD_DISCOUNT_CODE' : 'add discount code',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'add discount code',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'add discount code',
      }),
    },
  },
  addVoucher: {
    id: 'addVoucher',
    data: {
      event_type: 'CLUB_VOUCHER_ADD',
      event_id: 'Voucher Added',
      event_category: 'Club',
    },
  },
  addVoucherFromCart: {
    id: 'addVoucherFromCart',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'ADD_VOUCHER' : 'add voucher',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'add voucher',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'add voucher',
      }),
    },
  },
  removeVoucher: {
    id: 'removeVoucher',
    data: {
      event_type: 'CLUB_VOUCHER_REMOVE',
      event_id: 'Voucher Removed',
      event_category: 'Club',
    },
  },
  removeVoucherFromCart: {
    id: 'removeVoucherFromCart',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'REMOVE_VOUCHER' : 'remove voucher',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'remove voucher',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'remove voucher',
      }),
    },
  },
  removeDiscountFromCart: {
    id: 'removeDiscountFromCart',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'REMOVE_DISCOUNT_CODE' : 'remove discount code',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'remove discount code',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'remove discount code',
      }),
    },
  },
  addToFavourites: {
    id: 'addToFavourites',
    data: {
      event_type: 'ADD_TO_FAVOURITES',
      event_id: 'Add to favourites',
      event_category: 'Favourites',
    },
  },
  moveToFavouritesError: {
    id: 'moveToFavouritesError',
    data: {
      error_area: 'Shopping Bag',
      error_function: 'Move to favourites',
      error_message: 'move.to.favourites.error.general',
      error_type: 'SYSTEM',
    },
  },
  removeFromFavourites: {
    id: 'removeFromFavourites',
    data: {
      event_type: 'REMOVE_FROM_FAVOURITES',
      event_id: 'Remove from favourites',
      event_category: 'Favourites',
    },
  },
  invalidDiscount: {
    id: 'invalidDiscount',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'invalid_discount' : 'discount_added_failed',
      event_id: 'Invalid discount code',
      event_category: 'Discount',
    },
  },
  addToBag: {
    id: 'addToBag',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'ADD_TO_BAG' : 'add item',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      product_view_type: 'CART',
      ...(!(isHmBrand || isNorthstarBrand) && {
        event_id: 'CART',
        event_category: `Cart: ${currentBrand}`,
        page_type: 'cart',
        product_action: 'add',
      }),
    },
  },
  removeFromBag: {
    id: 'removeFromBag',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'REMOVE_FROM_BAG' : 'remove item',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      product_view_type: 'CART',
      ...(!(isHmBrand || isNorthstarBrand) && {
        event_id: 'CART',
        event_category: `Cart: ${currentBrand}`,
        page_type: 'cart',
        product_action: 'remove',
      }),
    },
  },
  removeFromBagError: {
    id: 'removeFromBagError',
    data: {
      error_area: 'Shopping bag',
      error_function: 'Remove from bag',
      error_message: 'remove.from.bag.error.general',
      error_type: 'SYSTEM',
    },
  },
  increaseProductQuantityInBag: {
    id: 'increaseProductQuantityInBag',
    data: {
      event_type:
        isHmBrand || isNorthstarBrand ? 'INCREASE_PRODUCT_QUANTITY' : 'increase product quantity',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      product_view_type: 'CART',
      ...(!(isHmBrand || isNorthstarBrand) && {
        event_id: 'CART',
        page_type: 'cart',
        product_action: 'increase quantity',
      }),
    },
  },
  increaseProductQuantityInBagError: {
    id: 'increaseProductQuantityInBagError',
    data: {
      error_area: 'Shopping bag',
      error_function: 'Increase quantity',
      error_message: 'increase.quantity.error.general',
      error_type: 'SYSTEM',
    },
  },
  decreaseProductQuantityInBag: {
    id: 'decreaseProductQuantityInBag',
    data: {
      event_type:
        isHmBrand || isNorthstarBrand ? 'DECREASE_PRODUCT_QUANTITY' : 'decrease product quantity',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      product_view_type: 'CART',
      ...(!(isHmBrand || isNorthstarBrand) && {
        event_id: 'CART',
        page_type: 'cart',
        product_action: 'decrease quantity',
      }),
    },
  },
  decreaseProductQuantityInBagError: {
    id: 'decreaseProductQuantityInBagError',
    data: {
      error_area: 'Shopping bag',
      error_function: 'Decrease quantity',
      error_message: 'decrease.quantity.error.general',
      error_type: 'SYSTEM',
    },
  },
  removeGiftCard: {
    id: 'removeGiftCard',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'REMOVE_GIFT_CARD' : 'remove gift card',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
      }),
    },
  },
  addGiftCard: {
    id: 'addGiftCard',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'ADD_GIFT_CARD' : 'add gift card',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
      }),
    },
  },
  giftCardError: {
    id: 'giftCardError',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'GIFT_CARD_ERROR' : 'gift card error',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
      }),
      ...((isHmBrand || isNorthstarBrand) && {
        error_area: 'Shopping bag',
        error_message: 'gift.card.error.general',
        error_type: 'SYSTEM',
      }),
    },
  },
  payWithGiftCardClick: {
    id: 'payWithGiftCardClick',
    data: {
      event_type:
        isHmBrand || isNorthstarBrand ? 'PAY_WITH_GIFT_CARD_CLICK' : 'pay with gift card click',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
      }),
    },
  },
  continueToCOClick: {
    id: 'continueToCOClick',
    data: {
      event_type:
        isHmBrand || isNorthstarBrand ? 'CLICK_CONTINUE_TO_CO_CTA' : 'click continue to co cta',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'Click continue to co cta',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'Click continue to co cta',
      }),
    },
  },
  loginClick: {
    id: 'loginClick',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'CLICK_LOGIN_CTA' : 'click login cta',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'Click login cta',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'Click login cta',
      }),
    },
  },
  returnAndRefundPolicyClick: {
    id: 'returnAndRefundPolicyClick',
    data: {
      event_type: 'click',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_name: 'return_and_refund_policy_link',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'Click return and refund policy cta',
      }),
    },
  },
  deliveryAndReturnsInfoClick: {
    id: 'deliveryAndReturnsInfoClick',
    data: {
      event_type: 'click',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_name: 'delivery_and_return_options',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'Click delivery and returns info cta',
      }),
    },
  },
  applyDiscountLink: {
    id: 'applyDiscountLink',
    data: {
      event_type: isHmBrand || isNorthstarBrand ? 'APPLY_DISCOUNT_LINK' : 'apply discount link',
      page_id: 'CART',
      category_id: 'SHOPPING_BAG',
      event_id: 'apply discount link',
      event_category: 'Cart',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        event_action: 'apply discount link',
      }),
    },
  },
  oneClickCheckoutClick: {
    id: 'oneClickCheckoutClick',
    data: {
      event_type: 'ONE_CLICK_CHECKOUT_BUY_NOW',
      event_id: 'Buy now clicked',
      event_category: 'One Click Checkout',
    },
  },
  oneClickCheckoutPopupShow: {
    id: 'oneClickCheckoutPopupShow',
    data: {
      event_type: 'ONE_CLICK_CHECKOUT_INFO',
      event_id: 'Information popup',
      event_category: 'One Click Checkout',
      event_label: 'First time experience',
    },
  },
  oneClickCheckoutError: {
    id: 'oneClickCheckoutError',
    data: {
      event_type: 'ONE_CLICK_CHECKOUT_ERROR',
      event_id: 'Error message',
      event_category: 'One Click Checkout',
    },
  },
  payPalCheckout: {
    id: 'payPalCheckout',
    data: {
      event_type: 'PAYPAL_SHORTCUT',
      event_id: 'Paypal shortcut',
      event_category: 'checkout interactions',
      event_label: 'Paypal shortcut clicked',
    },
  },
  payPalCheckoutError: {
    id: 'payPalCheckoutError',
    data: {
      event_type: 'PAYPAL_SHORTCUT_ERROR',
      event_id: 'Paypal shortcut',
      event_category: 'checkout interactions',
      event_label: 'paypal shortcut error',
    },
  },
  viewShoppingBag: {
    id: 'viewShoppingBag',
    data: {
      event_type: 'VIEW_SHOPPING_BAG',
      category_id: 'SHOPPING_BAG',
      page_id: 'CART',
      ...(!(isHmBrand || isNorthstarBrand) && {
        page_type: 'cart',
        product_action: 'checkout',
      }),
    },
  },
  clickPRAProduct: {
    id: 'clickPRAProduct',
    data: {
      event_type: 'PRODUCT_CLICK',
    },
  },
  impVisible: {
    id: 'impVisible',
    data: {
      event_type: 'IMP_VISIBLE',
    },
  },
  impVisibleClick: {
    id: 'impVisibleClick',
    data: {
      event_type: 'IMP_VISIBLE_CLICK',
    },
  },
  clickOrderCancellationOpening: {
    id: 'clickOrderCancellationOpening',
    data: {
      event_category: 'myAccount',
      event_id: 'openOrderCancellation',
      event_type: `MyAccount/openOrderCancellation`,
    },
  },
  clickAbortOrderCancellation: {
    id: 'clickAbortOrderCancellation',
    data: {
      event_category: 'myAccount',
      event_id: 'clickAbortOrderCancellation',
      event_type: `myAccount/clickAbortOrderCancellation`,
    },
  },
  clickOrderCancellationConfirmation: {
    id: 'clickOrderCancellationConfirmation',
    data: {
      event_category: 'myAccount',
      event_id: 'clickOrderCancellationConfirmation',
      event_type: `myAccount/clickOrderCancellationConfirmation`,
    },
  },
  orderCancellationError: {
    id: 'orderCancellationError',
    data: {
      event_category: 'myAccount',
      event_id: 'orderCancellationError',
      event_type: `myAccount/orderCancellationError`,
    },
  },
  orderCancellationFeedback: {
    id: 'orderCancellationFeedback',
    data: {
      event_category: 'myAccount',
      event_type: 'myAccount/orderCancellationFeedback',
      event_id: 'orderCancellationFeedback',
    },
  },
  accountCancellationFeedback: {
    id: 'accountCancellationFeedback',
    data: {
      event_category: 'myAccount',
      event_type: 'myAccount/accountCancellationFeedback',
      event_id: 'accountCancellationFeedback',
    },
  },
  offersPropositionValue: {
    id: 'offersPropositionValue',
    data: {
      event_category: 'myAccount',
      event_type: 'myAccount/offersPropositionValue',
      event_id: 'offersPropositionValue',
    },
  },
}

export const getVoucherTracking = (voucherCode: string): object => {
  return {
    dep_variable_name: [voucherCode],
    dep_variable_format: ['string'],
  }
}
